/* SMITHS 2.0 — The Smiths Sizer. Strap width, ring size, watch case and wrist at their true size
   on any screen, with nothing to hold up to the glass.
   Browsers never say how big a screen physically is, but they do show its exact shape (screen size
   in CSS px and pixel ratio) and, on most phones, its model. The sizer matches those against the
   makers' published panel specs (assets/smiths-screens.js, sources in data/screens-source.json):
       CSS px per mm = short side of the screen in CSS px ÷ short side of the panel in mm
   which stays true through Display Zoom, Android "display size" and resolution switches.
   Order: a screen the visitor chose before → the model the browser reports (Client Hints, in-app
   user agents) → the screen's shape (iPhone, iPad, MacBook) → one tap to choose the model, or the
   screen size in inches. On a desktop it can't recognise, it offers its QR to open on the phone.
   A bank card, coin or ruler remains only as the last resort. Never CSS mm (always 96 px per inch).
   Data (strings, standards, straps, QR codes) lives in #sz-data, written by Liquid. */
(() => {
  const root = document.querySelector('[data-sz]');
  const dataEl = document.getElementById('sz-data');
  if (!root || !dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const L = D.lang === 'ar' ? 'ar' : 'en';
  const T = D.t;
  const STD = D.std;
  const fill = (s, map) => String(s).replace(/%(\w)/g, (_, k) => (k in map ? map[k] : ''));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const KEY = 'smiths.sizer.screen.v2';
  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } },
    set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode: the choice lasts for this visit */ } },
  };
  let memo = null; // fallback when storage is blocked
  const publish = (name, data) => { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, data); } catch (e) { /* optional */ } };
  const n1 = (v) => (Math.round(v * 10) / 10).toFixed(1);
  const MM = L === 'ar' ? 'ملم' : 'mm', CM = L === 'ar' ? 'سم' : 'cm';
  const n2 = (v) => (Math.round(v * 100) / 100).toFixed(2);
  const AR_RE = new RegExp('[' + String.fromCharCode(0x600) + '-' + String.fromCharCode(0x6ff) + ']');
  const FSI = String.fromCharCode(0x2068), PDI = String.fromCharCode(0x2069);
  const iso = (s) => FSI + s + PDI; // keep Latin model names whole inside Arabic sentences (first-strong isolate)
  const inch = (v) => (L === 'ar' ? String(v) + ' بوصة' : String(v) + '″');

  /* ---------- the scale: recognise the screen ---------- */
  const dpr = () => window.devicePixelRatio || 1;
  const scr = () => ({ min: Math.min(screen.width, screen.height), max: Math.max(screen.width, screen.height) });
  const UA = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/.test(UA) || (/Macintosh/.test(UA) && navigator.maxTouchPoints > 1);
  const isMac = !isIOS && /Macintosh|Mac OS X/.test(UA);
  const touch = () => isIOS || window.matchMedia('(pointer: coarse)').matches;
  const shapeKey = (s, r) => s.min + 'x' + s.max + '@' + r;
  const norm = (s) => String(s).toLowerCase().replace(/[^a-z0-9+]/g, '');

  // device list: { b brand, n name, t type (p phone, t tablet, f foldable, l laptop, d desktop/display), y year,
  //   m [model codes], s [[W, H, short side mm, diagonal in, role]], k [screen keys "393x852@3"] }
  let DB = [];
  const BYID = new Map(), BYKEY = new Map();
  function index(list) {
    DB = list.filter((d) => d && d.s && d.s.length);
    DB.forEach((d) => {
      d.q = norm(d.b + ' ' + d.n + ' ' + (d.m || []).join(' '));
      (d.m || []).forEach((m) => { const k = m.toUpperCase(); if (!BYID.has(k)) BYID.set(k, d); });
      // "393x852@3" standard · "~320x693@3" with Display Zoom · "…#1" the device's second screen
      (d.k || []).forEach((k) => {
        const z = k[0] === '~', [kk, si] = (z ? k.slice(1) : k).split('#');
        const key = ('ld'.includes(d.t) ? 'm:' : 't:') + kk;
        if (!BYKEY.has(key)) BYKEY.set(key, []);
        BYKEY.get(key).push({ d, si: +si || 0, z });
      });
    });
  }
  async function loadDB() { // assets/smiths-screens.js, loaded just before this file
    if (DB.length) return;
    const j = window.SmithsScreens;
    if (j && j.d) index(j.d);
  }
  // the model the browser already reports: Client Hints (Chrome, Samsung Internet, Edge, Opera on Android),
  // the WebView user agent of in-app browsers, Instagram's and Facebook's device fields
  async function hints() {
    const out = [];
    try {
      const ch = navigator.userAgentData;
      if (ch && ch.getHighEntropyValues) { const h = await ch.getHighEntropyValues(['model']); if (h && h.model) out.push(h.model); }
    } catch (e) { /* not offered */ }
    let m;
    if ((m = UA.match(/\b(iP(?:hone|ad|od)\d+,\d+)\b/))) out.push(m[1]); // Instagram, Facebook (FBDV/…), TikTok on iOS
    if ((m = UA.match(/FBDV\/([^;\]]+)/))) out.push(m[1]);
    if ((m = UA.match(/Instagram [\d.]+ Android \((?:[^;]*;){4}\s*([^;]+);/))) out.push(m[1]);
    if ((m = UA.match(/Android [\d.]+;(?:\s*[a-z]{2}[-_][a-z]{2,4};)?\s*([^;)]+?)(?:\s+Build\/|\s*\)|;)/i))) out.push(m[1]);
    return [...new Set(out.map((x) => x.trim()))].filter((x) => x && !/^(K|wv|Mobile|Tablet|Linux|U)$/i.test(x));
  }
  function byModel(code) {
    const c = code.toUpperCase().replace(/\s+/g, ' ').trim();
    if (BYID.has(c)) return BYID.get(c);
    const sm = c.match(/^(SM-[A-Z]\d{3,4})/); // Samsung: SM-S921B/DS → SM-S921
    if (sm && BYID.has(sm[1])) return BYID.get(sm[1]);
    let best = null;
    for (const [k, d] of BYID) if (k.length >= 5 && c.startsWith(k) && (!best || k.length > best[0].length)) best = [k, d];
    return best ? best[1] : null;
  }
  const aspect = (x) => Math.max(x[0], x[1]) / Math.min(x[0], x[1]);
  function screenOf(d, s) { // foldables: the screen whose shape matches the one in use
    const a = s.max / s.min;
    let si = 0, bd = 9;
    d.s.forEach((x, i) => { const e = Math.abs(aspect(x) - a) / a; if (e < bd) { bd = e; si = i; } });
    return si;
  }
  function pxOf(c, s) {
    const x = c.d.s[c.si];
    // makers other than Apple state the diagonal; if this screen's real shape (which Android reports
    // in full, system bars included) differs from the listed resolution, trust the shape we see
    if (c.d.b !== 'Apple' && x[3]) {
      const a = s.max / s.min, A = x[1] / x[0];
      if (Math.abs(a - A) / A > 0.03) return s.min / ((x[3] * 25.4) / Math.hypot(1, a));
    }
    return s.min / x[2];
  }
  function label(list) { // several models with one panel: "iPhone · 6.1″", "iPad · 10.2″"
    if (list.length === 1) return list[0].d.n;
    const words = list.map((c) => c.d.n.split(' '));
    let k = 0;
    while (words.every((w) => w[k] && w[k] === words[0][k])) k++;
    const i = list[0].d.s[list[0].si][3];
    let head = words[0].slice(0, Math.max(1, k));
    const cut = head.findIndex((x, j) => j && (x[0] === '(' || /-inch/.test(x))); // "MacBook Pro (15-inch," → "MacBook Pro"
    if (cut > 0) head = head.slice(0, cut);
    return head.join(' ') + (i ? ' · ' + (Math.round(i * 10) / 10) + '″' : ''); // ″ keeps the label one left-to-right run in Arabic too
  }
  // models whose panels give the same scale (within 0.6%) are one choice: "iPhone X, XS, 11 Pro"
  function groups(list, s) {
    const g = [];
    list.slice().sort((a, b) => (a.d.y || 0) - (b.d.y || 0)).forEach((c) => {
      const p = pxOf(c, s);
      let x = g.find((q) => Math.abs(q.p - p) / q.p < 0.006);
      if (!x) g.push((x = { p, items: [] }));
      if (!x.items.some((i) => i.d.n === c.d.n)) x.items.push(c);
    });
    const newest = (x) => Math.max(...x.items.map((i) => i.d.y || 0));
    return g.sort((a, b) => newest(b) - newest(a));
  }
  function names(items, max = 100) {
    const w = items.map((c) => c.d.n.split(' '));
    let k = 0;
    while (k < w[0].length - 1 && w.every((x) => x[k] === w[0][k])) k++;
    const all = items.map((c, i) => (i ? w[i].slice(k).join(' ') : c.d.n)).join(' / ');
    return all.length > max ? label(items) : all; // ten MacBook generations read better as "MacBook Air · 13.3″"
  }
  function settle(list, s, how) {
    const px = list.map((c) => pxOf(c, s));
    const lo = Math.min(...px), hi = Math.max(...px);
    if (hi / lo < 1.006) {
      const uniq = list.filter((c, i) => list.findIndex((o) => o.d.n === c.d.n) === i);
      return { kind: 'sure', how, pxmm: px.reduce((a, b) => a + b, 0) / px.length, label: label(uniq), full: names(uniq, 60) };
    }
    return { kind: 'choose', how, groups: groups(list.filter((c) => !c.z), s), zoomed: groups(list.filter((c) => c.z), s) };
  }
  function fromSaved(s, r) {
    const c = store.get() || memo;
    if (!c || c.v !== 2 || !c.wmm) return null;
    const a = s.max / s.min;
    const same = c.sMin === s.min && c.sMax === s.max && Math.abs(c.dpr - r) < 0.01;
    const shape = Math.abs(a - c.a) / c.a < 0.015;
    // a phone or tablet keeps its panel through zoom and resolution changes; a computer's screen
    // can be swapped for a monitor of the same shape, so there only the exact same screen counts
    const ok = same || (c.touch && touch() && shape) || (c.keys && c.keys.includes(shapeKey(s, Math.round(r))));
    return ok ? { kind: 'sure', how: 'saved', pxmm: s.min / c.wmm, label: c.label, chosen: c.how } : null;
  }
  function remember(how, lbl, wmm, keys) {
    const s = scr();
    memo = { v: 2, how, label: lbl, wmm, a: s.max / s.min, touch: touch(), keys: keys || null, sMin: s.min, sMax: s.max, dpr: dpr(), ts: Date.now() };
    store.set(memo);
    publish('smiths_sizer_screen', { how });
  }
  async function recognise() {
    await loadDB();
    const s = scr(), r = dpr();
    const saved = fromSaved(s, r);
    if (saved) return saved;
    const hs = await hints();
    for (const h of hs) { const d = byModel(h); if (d) return settle([{ d, si: screenOf(d, s) }], s, 'model'); }
    if (isIOS) { const c = BYKEY.get('t:' + shapeKey(s, Math.round(r))); return c ? settle(c, s, 'shape') : { kind: 'unknown', model: null }; }
    if (isMac && !touch()) { const c = BYKEY.get('m:' + shapeKey(s, Math.round(r))); return c ? settle(c, s, 'shape') : { kind: 'desk' }; }
    if (touch()) return { kind: 'unknown', model: hs[0] || null };
    return { kind: 'desk' };
  }
  let R = null;
  const ready = recognise().catch(() => ({ kind: touch() ? 'unknown' : 'desk', model: null })).then((x) => { R = x; publish('smiths_sizer_recognised', { kind: x.kind, how: x.how || '' }); return x; });

  function zoomIssue() {
    const vv = window.visualViewport;
    if (vv && Math.abs(vv.scale - 1) > 0.02) return T.w_pinch;
    if (/iPhone/.test(UA) && innerHeight > innerWidth && Math.abs(innerWidth - screen.width) > 2) return T.w_pagezoom;
    if (!touch()) { // browser zoom on a computer shows up in the pixel ratio
      const r = dpr();
      if (isMac ? r !== 1 && r !== 2 : ![1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 3, 3.5, 4].some((x) => Math.abs(x - r) < 0.005)) return T.w_zoom;
    }
    return '';
  }

  /* ---------- ring and wrist arithmetic (sources in data/sizer-standards.json) ---------- */
  const FRAC = { 0: '', 0.25: '¼', 0.5: '½', 0.75: '¾' };
  const quarter = (v) => { const q = Math.round(v * 4) / 4; const w = Math.floor(q); return (w || (q - w) === 0 ? String(w) : '') + FRAC[q - w]; };
  const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  function ringSizes(C) {
    const d = C / Math.PI;
    const us = (d - 11.63) / 0.8128;
    const k = Math.round(((C - 37.5) / 1.25) * 2) / 2;
    let uk = '—';
    if (k >= 0) uk = k <= 25 ? LETTERS[Math.floor(k)] + (k % 1 ? '½' : '') : 'Z+' + (Math.floor(k - 25) || '') + ((k - 25) % 1 ? '½' : '');
    const jp = Math.round((d - 13.0) * 3 + 1);
    return { C, d, eu: Math.round(C), us: us >= 0 && us <= 16 ? quarter(us) : '—', uk, it: Math.round(C - 40), jp: jp >= 1 && jp <= 30 ? String(jp) : '—' };
  }
  function strapLength(cm) { return cm < 16.75 ? T.len_s : cm > 18.75 ? T.len_l : T.len_r; }
  function bangle(handC) {
    const dia = handC / Math.PI;
    const n = Math.round((dia / 25.4 - 2) * 16);
    return { dia, size: n >= 16 ? '3' + (n > 16 ? '-' + (n - 16) : '') : n >= 0 ? '2-' + n : '—' };
  }

  /* ---------- the overlay ---------- */
  const SVGNS = 'http://www.w3.org/2000/svg';
  const el = (tag, attrs, ...kids) => {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs || {})) if (v !== null && v !== undefined && v !== false) n.setAttribute(k, v);
    for (const kid of kids.flat()) if (kid !== null && kid !== undefined && kid !== false) n.append(kid instanceof Node ? kid : document.createTextNode(String(kid)));
    return n;
  };
  const ICON_X = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const ov = el('div', { class: 'sz-ov', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'sz-ttl', dir: L === 'ar' ? 'rtl' : 'ltr', lang: L, hidden: '' });
  ov.innerHTML = '<div class="sz-bar"><button type="button" class="sz-x"></button><p class="sz-ttl" id="sz-ttl"></p><span class="sz-mark" dir="ltr"><img alt="Smiths Boutique" width="66" height="24"></span></div>'
    + '<div class="sz-stage"><svg class="sz-svg" dir="ltr" aria-hidden="true" focusable="false"></svg><div class="sz-pick" hidden></div><p class="sz-help"></p><div class="sz-warn" role="alert" hidden></div></div>'
    + '<div class="sz-panel"><div class="sz-modes" role="group"></div><div class="sz-read" aria-live="polite"></div>'
    + '<div class="sz-ctl" dir="ltr"><button type="button" class="sz-step" data-s="-1">−</button><div class="sz-crown" role="slider" tabindex="0"><i></i></div><button type="button" class="sz-step" data-s="1">+</button></div>'
    + '<div class="sz-acts"></div></div><div class="sz-sheet" hidden></div>';
  document.body.append(ov);
  const $ = (s) => ov.querySelector(s);
  $('.sz-x').innerHTML = ICON_X; $('.sz-x').setAttribute('aria-label', T.close);
  $('.sz-mark img').src = D.logo;
  const svg = $('.sz-svg'), stage = $('.sz-stage'), help = $('.sz-help'), warn = $('.sz-warn'), pickEl = $('.sz-pick');
  const modesEl = $('.sz-modes'), readEl = $('.sz-read'), actsEl = $('.sz-acts'), crown = $('.sz-crown'), sheet = $('.sz-sheet');
  crown.setAttribute('aria-label', T.adjust);
  $('.sz-step[data-s="-1"]').setAttribute('aria-label', T.smaller);
  $('.sz-step[data-s="1"]').setAttribute('aria-label', T.larger);

  const S = { view: null, tool: 'strap', mode: null, pxmm: 6, v: 0, cal: null, after: null, pushed: false, lastFocus: null };
  const W = () => stage.clientWidth, H = () => stage.clientHeight;
  const P = () => S.pxmm;

  /* each view: { title, help, modes, value range, nudge rate, step, draw(), drag(x,y), read(), acts() } */
  const VIEWS = {};

  // calibration — card
  VIEWS.card = {
    title: () => T.cal_title,
    setup() {
      const g = S.pxmm;
      const wantY = H() - 60 >= 85.6 * g * 1.12;
      const wantX = W() - 48 >= 85.6 * g * 1.12;
      // the long edge (85.60 mm) is about 1.6x more exact than the short one; landscape screens lay it flat
      S.cal = wantX && W() >= H() ? { axis: 'x', ref: 85.6, other: 53.98 } : wantY ? { axis: 'y', ref: 85.6, other: 53.98 } : wantX ? { axis: 'x', ref: 85.6, other: 53.98 } : { axis: 'x', ref: 53.98, other: 85.6 };
      S.v = S.cal.ref * g;
      S.cal.o = S.cal.axis === 'y' ? 30 : Math.max(16, (W() - S.v) / 2);
    },
    help: () => T.cal_help + ' ' + T.cal_look,
    min: () => S.cal.ref * 2.5, max: () => (S.cal.axis === 'y' ? H() - S.cal.o - 6 : W() - S.cal.o - 6), step: () => 1 / dpr(), rate: 0.12,
    origin() { return S.cal.o; },
    draw() {
      const p = S.v / S.cal.ref, o = this.origin(), w = W(), h = H(), cw = S.cal.other * p, r = 3.18 * p;
      let s = '';
      if (S.cal.axis === 'y') {
        const x = (w - cw) / 2;
        s += `<rect class="sz-cardshape" x="${x}" y="${o}" width="${cw}" height="${S.v}" rx="${r}"/>`;
        s += `<rect class="sz-line sz-line--fix" x="0" y="${o - 2}" width="${w}" height="2"/><rect class="sz-line" x="0" y="${o + S.v}" width="${w}" height="2"/>`;
        s += `<text class="sz-lbl" x="${w - 10}" y="${o - 8}" text-anchor="end">0</text><text class="sz-lbl sz-lbl--hot" x="${w - 10}" y="${o + S.v + 18}" text-anchor="end">85.60 mm</text>`;
      } else {
        const y = Math.max(20, (h - (S.cal.other * p)) / 2);
        const ch = S.cal.other * p;
        s += `<rect class="sz-cardshape" x="${o}" y="${y}" width="${S.v}" height="${ch}" rx="${r}"/>`;
        s += `<rect class="sz-line sz-line--fix" x="${o - 2}" y="0" width="2" height="${h}"/><rect class="sz-line" x="${o + S.v}" y="0" width="2" height="${h}"/>`;
        s += `<text class="sz-lbl" x="${o - 8}" y="16" text-anchor="end">0</text><text class="sz-lbl sz-lbl--hot" x="${o + S.v + 8}" y="16">${S.cal.ref.toFixed(2)} mm</text>`;
      }
      return s;
    },
    drag(x, y) { S.v = S.cal.axis === 'y' ? y - this.origin() : x - this.origin(); },
    read() { return [el('b', { class: 'sz-big sz-big--s' }, T.cal_card), el('span', {}, T.cal_tip)]; },
    acts() {
      return [btn(T.cal_save, 'ink', () => saveAndGo('card')), link(T.cal_coin, () => show('coin')), link(T.cal_ruler, () => show('ruler')), link(T.back, () => show('pick'))];
    },
  };
  // calibration — coin
  VIEWS.coin = {
    title: () => T.cal_title,
    setup() { S.coin = S.coin || STD.coins[0]; S.v = S.coin.mm * S.pxmm; },
    modes: () => STD.coins.map((c) => ({ id: c.id, label: c[L] + ' · ' + c.mm.toFixed(2) + ' ' + MM, on: S.coin.id === c.id, go: () => { const p = S.v / S.coin.mm; S.coin = c; S.v = c.mm * p; render(); } })),
    help: () => T.coin_help + ' ' + T.cal_look,
    min: () => S.coin.mm * 2.5, max: () => S.coin.mm * 14, step: () => 1 / dpr(), rate: 0.08,
    draw() { const cx = W() / 2, cy = H() / 2, r = S.v / 2; return `<circle class="sz-ghost" cx="${cx}" cy="${cy}" r="${r}"/><circle class="sz-ring" cx="${cx}" cy="${cy}" r="${r + 1}"/>` + cross(cx, cy, r); },
    drag(x, y) { S.v = 2 * Math.hypot(x - W() / 2, y - H() / 2); },
    read() { return [el('b', { class: 'sz-big sz-big--s' }, S.coin[L]), el('span', {}, T.coin_tip)]; },
    acts() { return [btn(T.cal_save, 'ink', () => saveAndGo('coin', S.v / S.coin.mm)), link(T.cal_back_card, () => show('card'))]; },
  };
  // calibration — ruler
  VIEWS.ruler = {
    title: () => T.cal_title,
    setup() { S.v = 50; },
    help: () => T.ruler_help,
    noCtl: true,
    draw() {
      const p = S.pxmm, len = 50 * p, x0 = Math.max(16, (W() - len) / 2), y = H() / 2;
      let s = `<rect class="sz-bar50" x="${x0}" y="${y - 6}" width="${len}" height="12"/>`;
      for (let i = 0; i <= 50; i += 5) s += `<rect class="sz-tick${i % 10 ? '' : ' sz-tick--maj'}" x="${x0 + i * p - 0.5}" y="${y + 10}" width="1" height="${i % 10 ? 6 : 11}"/>`;
      return s;
    },
    read() {
      const inp = el('input', { type: 'number', inputmode: 'decimal', min: '20', max: '120', step: '0.5', class: 'sz-input', 'aria-label': T.ruler_label, placeholder: '50' });
      inp.addEventListener('input', () => { S.rulerVal = parseFloat(inp.value); });
      return [el('label', { class: 'sz-inlabel' }, T.ruler_label, inp)];
    },
    acts() {
      return [btn(T.cal_save, 'ink', () => { const r = S.rulerVal; if (!(r >= 20 && r <= 120)) return; saveAndGo('ruler', S.pxmm * 50 / r); }), link(T.cal_back_card, () => show('card'))];
    },
  };

  // the screen: a moment while the list loads
  VIEWS.wait = { title: () => T.t_screen, help: () => T.status_wait, noCtl: true, draw: () => '', read: () => [], acts: () => [] };

  // the screen: choose the model (two models share a shape, or the browser doesn't say), or type the inches
  const DESK_IN = [13.3, 13.6, 14, 15.3, 15.6, 16, 17.3, 21.5, 23.8, 27, 31.5, 34];
  VIEWS.pick = {
    title: () => (touch() ? T.pick_title : T.pick_title_desk),
    help: () => '', noCtl: true,
    html() {
      const s = scr(), a = s.max / s.min, onTouch = touch(), kids = [];
      const choose = R && R.kind === 'choose', onlyZoom = choose && !R.groups.length;
      const lead = onlyZoom ? T.pick_zoomed : choose ? T.pick_two : R && R.model ? fill(T.pick_known, { m: iso(R.model) }) : onTouch ? T.pick_unknown : T.pick_desk;
      kids.push(el('p', { class: 'sz-pick__lead' }, lead));
      if (choose) {
        if (R.groups.length) kids.push(el('div', { class: 'sz-cands' }, R.groups.map((g) => candBtn(g.items, true))));
        if (R.zoomed.length) {
          if (!onlyZoom) kids.push(el('p', { class: 'sz-pick__k' }, T.pick_zoom));
          kids.push(el('div', { class: 'sz-cands' }, R.zoomed.map((g) => candBtn(g.items, onlyZoom))));
        }
      }
      if (!onTouch) {
        const chips = el('div', { class: 'sz-chips' }, DESK_IN.map((v) => { const b = el('button', { type: 'button', class: 's2-chip', dir: 'ltr' }, L === 'ar' ? String(v) : inch(v)); b.addEventListener('click', () => byInches(v)); return b; }));
        kids.push(el('p', { class: 'sz-pick__k' }, T.inch_label), chips);
      }
      const q = el('input', { type: 'search', class: 'sz-search', placeholder: onTouch ? T.pick_search : T.pick_search_desk, 'aria-label': onTouch ? T.pick_search : T.pick_search_desk, autocomplete: 'off', autocapitalize: 'off', spellcheck: 'false', enterkeyhint: 'search', dir: L === 'ar' ? 'rtl' : 'ltr' });
      const list = el('div', { class: 'sz-res' }), cap = el('p', { class: 'sz-pick__k' });
      const update = () => {
        const typed = !!q.value.trim();
        const res = typed || !choose ? search(q.value, a, onTouch) : [];
        cap.textContent = typed ? (res.length ? T.pick_found : T.pick_none) : choose ? T.pick_other : res.length ? (onTouch ? T.pick_like : T.pick_mac) : T.pick_type;
        list.replaceChildren(...res.map((c) => candBtn([c], false, true)));
      };
      q.addEventListener('input', update);
      update();
      kids.push(cap, q, list);
      const inp = el('input', { type: 'number', inputmode: 'decimal', min: '3', max: '100', step: '0.01', class: 'sz-input', 'aria-label': T.inch_label, placeholder: onTouch ? '6.1' : '15.6', dir: 'ltr' });
      const use = btn(T.inch_use, 'line', () => { const v = parseFloat(String(inp.value).replace(',', '.')); if (!byInches(v)) { inp.focus(); inp.setAttribute('aria-invalid', 'true'); } });
      inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') use.click(); });
      kids.push(el('div', { class: 'sz-inch' }, el('label', { class: 'sz-inlabel' }, onTouch ? T.inch_label : T.inch_other, inp), use), el('p', { class: 'sz-pick__hint' }, T.inch_hint));
      return el('div', { class: 'sz-pick__in' }, kids);
    },
    read: () => [],
    acts() {
      const a = [];
      if (R && R.kind === 'sure') a.push(btn(T.back, 'line', () => goTool()));
      if (!touch()) a.push(link(T.on_phone, () => show('desk')));
      a.push(link(T.use_card, () => show('card')));
      return a;
    },
  };
  function candBtn(items, big, year) {
    const c = items[items.length - 1], x = c.d.s[c.si];
    const b = el('button', { type: 'button', class: 'sz-cand' + (big ? ' sz-cand--big' : ''), dir: 'ltr' },
      el('b', {}, names(items)), el('span', { dir: L === 'ar' ? 'rtl' : 'ltr' }, [x[3] ? inch(Math.round(x[3] * 10) / 10) : '', x[4] === 'c' ? T.cover : x[4] === 'i' ? T.inner : '', year ? c.d.y : ''].filter(Boolean).join(' · ')));
    b.addEventListener('click', () => pickDevice(c, items.length > 1 ? names(items, 40) : c.d.n));
    return b;
  }
  function search(qs, a, onTouch) {
    const nq = norm(qs), kinds = onTouch ? 'ptf' : 'ld';
    if (!nq && !onTouch && !isMac) return []; // a Windows or Linux screen: nothing in the list is "like" it
    const fit = (c) => Math.abs(aspect(c.d.s[c.si]) - a) / a;
    const near = (c) => (fit(c) < 0.025 ? 1 : 0);
    const best = new Map();
    const android = /Android/i.test(UA);
    for (const d of DB) {
      if (!kinds.includes(d.t)) continue;
      if ((isIOS && d.b !== 'Apple') || (android && d.b === 'Apple')) continue; // an iPhone is never an Android phone
      if (nq && !d.q.includes(nq)) continue;
      const c = { d, si: d.s.length > 1 ? screenOf(d, { min: 1, max: a }) : 0 };
      if (!nq && fit(c) > 0.025) continue; // with no query: only screens shaped exactly like this one
      best.set(d, c);
    }
    const W = { Apple: 3, Samsung: 3, HUAWEI: 2, Huawei: 2, HONOR: 1, Honor: 1, Xiaomi: 1, Redmi: 1 }; // what Kuwait carries most
    const rank = (c) => (nq ? 0 : W[c.d.b] || 0);
    return [...best.values()].sort((p, q) => near(q) - near(p) || rank(q) - rank(p) || (q.d.y || 0) - (p.d.y || 0)).slice(0, nq ? 12 : 6);
  }
  function pickDevice(c, lbl) {
    const s = scr(), x = c.d.s[c.si];
    remember('picked', lbl, x[2], 'ld'.includes(c.d.t) ? (c.d.k || []).map((k) => k.replace(/^~|#\d+$/g, '')) : null);
    R = { kind: 'sure', how: 'picked', pxmm: s.min / x[2], label: lbl };
    toast(fill(T.saved_dev, { d: iso(lbl) })); syncStatus(); goTool();
  }
  function byInches(v) {
    const s = scr();
    if (!(v >= 3 && v <= 100)) return false;
    const ppi = Math.hypot(s.min, s.max) * dpr() / v; // a real panel sits between about 70 and 600 pixels per inch
    if (ppi < 60 || ppi > 640) return false;
    const wmm = (v * 25.4 * s.min) / Math.hypot(s.min, s.max);
    remember('inches', v + '″', wmm, null);
    R = { kind: 'sure', how: 'inches', pxmm: s.min / wmm, label: v + '″' };
    toast(fill(T.saved_dev, { d: iso(v + '″') })); syncStatus(); goTool();
    return true;
  }

  // a computer it can't recognise: open the sizer on the phone, which knows its own screen.
  // The QR codes are made at build time (build_sizer.py) and arrive as bits; this draws them.
  function qrPath(q) {
    const bin = atob(q.b), bit = (i) => (bin.charCodeAt(i >> 3) >> (7 - (i & 7))) & 1;
    let d = '';
    for (let y = 0; y < q.n; y++) {
      for (let x = 0; x < q.n;) {
        if (!bit(y * q.n + x)) { x++; continue; }
        const x0 = x;
        while (x < q.n && bit(y * q.n + x)) x++;
        d += `M${x0} ${y}h${x - x0}v1h-${x - x0}z`;
      }
    }
    return d;
  }
  VIEWS.desk = {
    title: () => T.desk_title, help: () => '', noCtl: true,
    html() {
      const q = D.qr && (D.qr[S.after] || D.qr.strap);
      const box = el('div', { class: 'sz-qr', dir: 'ltr' });
      if (q) box.innerHTML = `<svg viewBox="0 0 ${q.n + 8} ${q.n + 8}" role="img" aria-label="${T.desk_title}"><rect width="100%" height="100%" fill="#fff"/><path d="${qrPath(q)}" transform="translate(4 4)" fill="#16140F"/>`
        + `<g transform="translate(${(q.n + 8) / 2} ${(q.n + 8) / 2})"><rect x="-4.5" y="-4.5" width="9" height="9" fill="#fff"/><text x="0" y="2.55" text-anchor="middle" font-size="7.4" font-weight="500" fill="#16140F" style="font-family:var(--s2-f, Archivo, Helvetica, sans-serif)">S</text><rect x="-3.2" y="3.3" width="6.4" height=".45" fill="#9A5526"/></g></svg>`;
      return el('div', { class: 'sz-desk' }, box, el('p', { class: 'sz-desk__url', dir: 'ltr' }, q ? q.t : 'smiths.watch/sizer'), el('p', { class: 'sz-pick__lead' }, T.desk_help));
    },
    read: () => [],
    acts: () => [btn(T.desk_here, 'line', () => show('pick'))],
  };

  // tools
  const STRAP_STD = [16, 17, 18, 19, 20, 21, 22, 23, 24];
  VIEWS.strap = {
    title: () => T.t_strap,
    modes: () => [{ id: 'exact', label: T.m_exact }, { id: 'quick', label: T.m_quick }].map((m) => ({ ...m, on: S.mode === m.id, go: () => { S.mode = m.id; render(); } })),
    setup() { S.mode = S.mode === 'quick' ? 'quick' : 'exact'; S.v = S.v && S.tool === 'strap' ? S.v : 20; },
    help: () => (S.mode === 'quick' ? T.strap_help_quick : T.strap_help),
    min: () => 8, max: () => 32, step: () => 0.1, rate: 0.02,
    noCtl: () => S.mode === 'quick',
    draw() {
      const p = P(), w = W(), h = H(), cx = w / 2;
      if (S.mode === 'exact') {
        const xl = cx - (S.v / 2) * p, xr = cx + (S.v / 2) * p;
        let s = `<rect class="sz-fillband" x="${xl}" y="0" width="${xr - xl}" height="${h}"/>`;
        s += `<rect class="sz-line sz-line--fix" x="${xl - 2}" y="0" width="2" height="${h}"/><rect class="sz-line" x="${xr}" y="0" width="2" height="${h}"/>`;
        // standard widths sit only half a millimetre apart on each side, so only the nearest one is named
        const near = clamp(Math.round(S.v), 16, 24);
        for (const mm of STRAP_STD) { const x = cx + (mm / 2) * p; s += `<rect class="sz-tick${mm === near ? ' sz-tick--hot' : mm % 2 ? '' : ' sz-tick--maj'}" x="${x}" y="0" width="1" height="${mm === near ? 16 : mm % 2 ? 6 : 10}"/>`; }
        if (Math.abs(S.v - near) <= 1.5) s += `<text class="sz-lbl sz-lbl--hot" x="${cx + (near / 2) * p + 6}" y="28">${near}</text>`;
        return s;
      }
      // the taper gauge: 16 mm at the top, 24 mm at the bottom; 1 mm of width = 10 mm of length
      const len = Math.min(h - 40, 80 * p), y0 = (h - len) / 2, per = len / 8;
      const half = (y) => (16 + ((y - y0) / len) * 8) / 2 * p;
      let s = `<path class="sz-v" d="M${cx - 8 * p} ${y0} L${cx - 12 * p} ${y0 + len} M${cx + 8 * p} ${y0} L${cx + 12 * p} ${y0 + len}"/>`;
      for (let i = 0; i <= 16; i++) {
        const y = y0 + (i * per) / 2, hw = half(y), mm = 16 + i / 2;
        s += `<rect class="sz-tick${i % 2 ? '' : ' sz-tick--maj'}" x="${cx + hw + 3}" y="${y - 0.5}" width="${i % 2 ? 5 : 10}" height="1"/><rect class="sz-tick${i % 2 ? '' : ' sz-tick--maj'}" x="${cx - hw - 3 - (i % 2 ? 5 : 10)}" y="${y - 0.5}" width="${i % 2 ? 5 : 10}" height="1"/>`;
        if (i % 2 === 0) s += `<text class="sz-lbl sz-tap${S.v === mm ? ' sz-lbl--hot' : ''}" data-mm="${mm}" x="${cx + hw + 18}" y="${y + 4}">${mm}</text>`;
      }
      if (S.qy != null) { const hw = half(S.qy); s += `<rect class="sz-cursor" x="${cx - hw - 14}" y="${S.qy - 0.75}" width="${2 * hw + 28}" height="1.5"/>`; }
      return s;
    },
    drag(x, y, ev) {
      if (S.mode === 'exact') { S.v = 2 * Math.abs(x - W() / 2) / P(); return; }
      const t = ev && ev.target && ev.target.getAttribute && ev.target.getAttribute('data-mm');
      const len = Math.min(H() - 40, 80 * P()), y0 = (H() - len) / 2;
      if (t) { S.v = +t; S.qy = y0 + ((S.v - 16) / 8) * len; return; }
      const yy = clamp(y, y0, y0 + len); S.qy = yy; S.v = Math.round((16 + ((yy - y0) / len) * 8) * 10) / 10;
    },
    read() {
      const near = Math.round(S.v), off = Math.abs(S.v - near) > 0.3;
      return [el('b', { class: 'sz-big', dir: 'auto' }, n1(S.v) + ' ' + MM), el('span', {}, off ? T.strap_between : fill(T.strap_near, { w: near }))];
    },
    acts: toolActs,
  };
  VIEWS.ring = {
    title: () => T.t_ring,
    // paper-strip mode reads the strip folded in half (so even 76 mm fits a small phone): C = 2 × v
    modes: () => [{ id: 'ring', label: T.m_ring }, { id: 'strip', label: T.m_strip }].map((m) => ({ ...m, on: S.mode === m.id, go: () => { const C = S.mode === 'ring' ? S.v * Math.PI : S.v * 2; S.mode = m.id; S.v = m.id === 'ring' ? C / Math.PI : C / 2; render(); } })),
    setup() { S.mode = S.mode === 'strip' ? 'strip' : 'ring'; if (!(S.tool === 'ring' && S.v)) S.v = S.mode === 'ring' ? 17.32 : 27.2; },
    help: () => (S.mode === 'ring' ? T.ring_help : T.strip_help),
    min: () => (S.mode === 'ring' ? 11 : 17), max: () => (S.mode === 'ring' ? 26 : 41), step: () => 0.05, rate: 0.01,
    draw() {
      const p = P();
      if (S.mode === 'ring') { const cx = W() / 2, cy = H() / 2, r = (S.v / 2) * p; return `<circle class="sz-ghost" cx="${cx}" cy="${cy}" r="${r}"/><circle class="sz-ring" cx="${cx}" cy="${cy}" r="${r + 1}"/>` + cross(cx, cy, r); }
      return rulerY(p, S.v, 45);
    },
    drag(x, y) { if (S.mode === 'ring') S.v = 2 * Math.hypot(x - W() / 2, y - H() / 2) / P(); else S.v = (y - 28) / P(); },
    read() {
      const C = S.mode === 'ring' ? S.v * Math.PI : S.v * 2, r = ringSizes(C);
      return [el('b', { class: 'sz-big', dir: 'ltr' }, 'EU ' + r.eu + ' · US ' + r.us),
        el('span', { class: 'sz-sys', dir: 'ltr' }, 'UK ' + r.uk + ' · IT ' + r.it + ' · JP ' + r.jp + ' · Ø ' + n2(r.d) + ' mm · C ' + n1(r.C) + ' mm')];
    },
    acts: toolActs,
  };
  VIEWS.case = {
    title: () => T.t_case,
    setup() { if (!(S.tool === 'case' && S.v)) S.v = 40; },
    help: () => T.case_help,
    min: () => 16, max: () => 62, step: () => 0.1, rate: 0.02,
    draw() { const p = P(), cx = W() / 2, cy = H() / 2, r = (S.v / 2) * p; return `<circle class="sz-ghost" cx="${cx}" cy="${cy}" r="${r}"/><circle class="sz-ring" cx="${cx}" cy="${cy}" r="${r + 1}"/>` + cross(cx, cy, r); },
    drag(x, y) { S.v = 2 * Math.hypot(x - W() / 2, y - H() / 2) / P(); },
    read() { return [el('b', { class: 'sz-big', dir: 'auto' }, n1(S.v) + ' ' + MM), el('span', {}, T.case_read)]; },
    acts: toolActs,
  };
  VIEWS.wrist = {
    title: () => T.t_wrist,
    // the strip is folded in quarters (fold in half, then in half again), so a wrist fits any phone: C = 4 × v
    modes: () => [{ id: 'wrist', label: T.m_wrist }, { id: 'hand', label: T.m_hand }].map((m) => ({ ...m, on: S.mode === m.id, go: () => { S.mode = m.id; S.v = m.id === 'hand' ? 50 : 42.5; render(); } })),
    setup() { S.mode = S.mode === 'hand' ? 'hand' : 'wrist'; if (!(S.tool === 'wrist' && S.v)) S.v = S.mode === 'hand' ? 50 : 42.5; },
    help: () => (S.mode === 'hand' ? T.hand_help : T.wrist_help),
    min: () => 25, max: () => 70, step: () => 0.1, rate: 0.02,
    horizontal: () => W() > H() * 1.15,
    draw() { const p = P(); return this.horizontal() ? rulerX(p, S.v, 70) : rulerY(p, S.v, 70); },
    drag(x, y) { S.v = (this.horizontal() ? x - 24 : y - 28) / P(); },
    read() {
      const C = 4 * S.v;
      if (S.mode === 'hand') { const b = bangle(C); return [el('b', { class: 'sz-big', dir: 'auto' }, n1(b.dia) + ' ' + MM + ' Ø'), el('span', {}, fill(T.hand_read, { s: b.size, c: Math.round(C) }))]; }
      const cm = C / 10, A = STD.allow;
      return [el('b', { class: 'sz-big', dir: 'auto' }, n1(cm) + ' ' + CM),
        el('span', {}, fill(T.wrist_read, { l: strapLength(cm), a: n1(cm + A.snug), b: n1(cm + A.comfort), c: n1(cm + A.loose) }))];
    },
    acts: toolActs,
  };

  /* drawing helpers */
  function cross(cx, cy, r) { const e = r + 22; return `<rect class="sz-hair" x="${cx - e}" y="${cy - 0.5}" width="${2 * e}" height="1"/><rect class="sz-hair" x="${cx - 0.5}" y="${cy - e}" width="1" height="${2 * e}"/>`; }
  function rulerY(p, v, maxmm) {
    const x = Math.max(16, W() / 2 - 80), y0 = 28, top = Math.min(maxmm, Math.floor((H() - 28 - 60) / p));
    let s = `<rect class="sz-line sz-line--fix" x="0" y="${y0 - 2}" width="${W()}" height="2"/><text class="sz-lbl" x="${W() - 10}" y="${y0 - 8}" text-anchor="end">0</text>`;
    for (let i = 0; i <= top; i++) {
      const y = y0 + i * p, maj = i % 10 === 0, mid = i % 5 === 0;
      s += `<rect class="sz-tick${maj ? ' sz-tick--maj' : ''}" x="${x}" y="${y - 0.5}" width="${maj ? 26 : mid ? 18 : 10}" height="1"/>`;
      if (maj && i) s += `<text class="sz-lbl sz-lbl--s" x="${x + 32}" y="${y + 4}">${i}</text>`;
    }
    const ym = y0 + v * p;
    s += `<rect class="sz-line" x="0" y="${ym}" width="${W()}" height="2"/><text class="sz-lbl sz-lbl--hot" x="${W() - 10}" y="${ym + 18}" text-anchor="end">${n1(v)} mm</text>`;
    return s;
  }
  function rulerX(p, v, maxmm) {
    const x0 = 24, y = Math.max(20, H() / 2 - 40), top = Math.min(maxmm, Math.floor((W() - 40) / p));
    let s = `<rect class="sz-line sz-line--fix" x="${x0 - 2}" y="0" width="2" height="${H()}"/><text class="sz-lbl" x="${x0 + 6}" y="16">0</text>`;
    for (let i = 0; i <= top; i++) {
      const x = x0 + i * p, maj = i % 10 === 0, mid = i % 5 === 0;
      s += `<rect class="sz-tick${maj ? ' sz-tick--maj' : ''}" x="${x - 0.5}" y="${y}" width="1" height="${maj ? 26 : mid ? 18 : 10}"/>`;
      if (maj && i) s += `<text class="sz-lbl sz-lbl--s" x="${x}" y="${y + 42}" text-anchor="middle">${i}</text>`;
    }
    const xm = x0 + v * p;
    s += `<rect class="sz-line" x="${xm}" y="0" width="2" height="${H()}"/><text class="sz-lbl sz-lbl--hot" x="${xm + 8}" y="16">${n1(v)} mm</text>`;
    return s;
  }
  function link(label, fn) { const r = el('button', { type: 'button', class: 'sz-link' }, label); r.addEventListener('click', fn); return r; }
  function toolActs() {
    const chip = el('button', { type: 'button', class: 'sz-dev' }, el('span', {}, fill(T.dev_sized, { d: iso(R && R.label ? R.label : '') })), el('u', {}, T.change));
    chip.addEventListener('click', () => { S.after = S.view; show('pick'); });
    return [btn(T.done, 'ink', () => result()), chip];
  }
  function btn(label, kind, fn) { const b = el('button', { type: 'button', class: 's2-btn s2-btn--' + kind }, label); b.addEventListener('click', fn); return b; }

  /* ---------- render ---------- */
  function render() {
    const V = VIEWS[S.view];
    if (!V) return;
    $('.sz-ttl').textContent = V.title();
    help.textContent = V.help(); help.hidden = !help.textContent;
    const modes = V.modes ? V.modes() : [];
    modesEl.replaceChildren(...modes.map((m) => { const b = el('button', { type: 'button', class: 's2-chip' + (m.on ? ' s2-chip--on' : ''), 'aria-pressed': m.on ? 'true' : 'false' }, m.label); b.addEventListener('click', m.go); return b; }));
    modesEl.hidden = !modes.length;
    const noCtl = typeof V.noCtl === 'function' ? V.noCtl() : V.noCtl;
    $('.sz-ctl').hidden = !!noCtl;
    if (V.min) S.v = clamp(S.v, V.min(), V.max());
    // list views (choose the screen, the QR) are built once in show(); drawings are redrawn on every change
    pickEl.hidden = !V.html; svg.style.display = V.html ? 'none' : '';
    stage.classList.toggle('is-list', !!V.html);
    if (!V.html) { svg.setAttribute('viewBox', '0 0 ' + W() + ' ' + H()); svg.innerHTML = V.draw(); }
    readEl.replaceChildren(...V.read());
    readEl.hidden = !readEl.childNodes.length;
    actsEl.replaceChildren(...V.acts());
    crown.setAttribute('aria-valuenow', String(Math.round(S.v * 100) / 100));
    crown.querySelector('i').style.backgroundPositionX = (-(S.v * 40) % 12) + 'px';
    const z = V.html || view0(S.view) ? '' : zoomIssue();
    warn.textContent = z; warn.hidden = !z;
  }
  const view0 = (v) => v === 'wait';
  function show(view) {
    S.view = view; const V = VIEWS[view];
    if (view === 'card' || view === 'coin') { // the card outline starts from the best guess there is
      const g = R && R.kind === 'choose' ? (R.groups[0] || R.zoomed[0]) : null;
      S.pxmm = R && R.kind === 'sure' ? R.pxmm : g ? g.p : touch() ? 6.3 : 4.4;
    }
    if (V.setup) V.setup();
    sheet.hidden = true;
    if (V.html) { pickEl.replaceChildren(V.html()); pickEl.scrollTop = 0; }
    render();
  }

  /* ---------- input: drag on the stage, the crown, the step buttons, the keyboard ---------- */
  let dragging = false;
  const local = (e) => { const r = svg.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  stage.addEventListener('pointerdown', (e) => {
    const V = VIEWS[S.view];
    if (!V || !V.drag || e.target.closest('.sz-warn')) return;
    dragging = true; stage.setPointerCapture(e.pointerId);
    const [x, y] = local(e); V.drag(x, y, e); render();
  });
  stage.addEventListener('pointermove', (e) => { if (!dragging) return; const [x, y] = local(e); VIEWS[S.view].drag(x, y); render(); });
  const stop = () => { if (dragging) { dragging = false; } };
  stage.addEventListener('pointerup', stop); stage.addEventListener('pointercancel', stop);

  let cx0 = null;
  crown.addEventListener('pointerdown', (e) => { cx0 = e.clientX; crown.setPointerCapture(e.pointerId); crown.classList.add('is-on'); });
  crown.addEventListener('pointermove', (e) => {
    if (cx0 === null) return;
    const V = VIEWS[S.view], dx = e.clientX - cx0; cx0 = e.clientX;
    S.v += dx * (V.rate || 0.02); render();
  });
  const crownEnd = () => { cx0 = null; crown.classList.remove('is-on'); };
  crown.addEventListener('pointerup', crownEnd); crown.addEventListener('pointercancel', crownEnd);
  crown.addEventListener('keydown', (e) => {
    const V = VIEWS[S.view]; if (!V || !V.step) return;
    const k = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1, PageUp: 10, PageDown: -10 }[e.key];
    if (!k) return; e.preventDefault(); S.v += k * V.step(); render();
  });
  let rep = null;
  const stepOnce = (dir) => { const V = VIEWS[S.view]; if (V && V.step) { S.v += dir * V.step(); render(); } };
  ov.querySelectorAll('.sz-step').forEach((b) => {
    const dir = +b.dataset.s;
    b.addEventListener('pointerdown', (e) => {
      e.preventDefault(); stepOnce(dir);
      let n = 0;
      rep = setTimeout(function go() { stepOnce(dir * (n > 25 ? 4 : 1)); n++; rep = setTimeout(go, 60); }, 380);
    });
    const end = () => { clearTimeout(rep); rep = null; };
    ['pointerup', 'pointerleave', 'pointercancel'].forEach((ev) => b.addEventListener(ev, end));
    b.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stepOnce(dir); } });
  });

  /* ---------- open, close, calibrate ---------- */
  async function openTool(tool, then) {
    S.tool = tool; S.mode = null; S.v = 0; S.qy = null; S.after = tool;
    S.lastFocus = document.activeElement;
    ov.hidden = false; document.documentElement.classList.add('sz-lock');
    if (!S.pushed) { try { history.pushState({ sz: tool }, '', '#' + tool); S.pushed = true; } catch (e) { /* file:// */ } }
    $('.sz-x').focus();
    publish('smiths_sizer_open', { tool });
    if (!R) { show('wait'); await ready; if (ov.hidden) return; }
    if (then) return show(then);
    if (R.kind === 'sure') return goTool();
    show(R.kind === 'desk' ? 'desk' : 'pick');
  }
  function goTool() {
    const t = S.after in TOOLS ? S.after : S.tool in TOOLS ? S.tool : 'strap';
    S.pxmm = R.pxmm; S.tool = t; S.view = t; S.v = 0; S.qy = null; S.mode = null;
    VIEWS[t].setup(); sheet.hidden = true; render();
  }
  function saveAndGo(method, pxmm) { // the last resort: a card, a coin or a ruler
    const p = pxmm || S.v / S.cal.ref, s = scr();
    remember(method, T.lbl_card, s.min / p, null);
    R = { kind: 'sure', how: method, pxmm: p, label: T.lbl_card };
    toast(T.cal_saved); syncStatus(); goTool();
  }
  function close(fromPop) {
    ov.hidden = true; sheet.hidden = true; document.documentElement.classList.remove('sz-lock');
    if (S.pushed && !fromPop) { S.pushed = false; try { history.back(); } catch (e) { /* noop */ } }
    S.pushed = false;
    if (S.lastFocus && S.lastFocus.focus) S.lastFocus.focus();
  }
  $('.sz-x').addEventListener('click', () => close(false));
  ov.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(false); });
  window.addEventListener('popstate', () => { if (!ov.hidden) close(true); });
  window.addEventListener('resize', () => { if (!ov.hidden) render(); });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', () => { if (!ov.hidden) render(); });
  let toastT = 0;
  function toast(msg) { const t = el('div', { class: 'sz-toast', role: 'status' }, msg); ov.append(t); clearTimeout(toastT); toastT = setTimeout(() => t.remove(), 2600); }
  const TOOLS = { strap: 1, ring: 1, case: 1, wrist: 1 };

  /* ---------- the result sheet + a branded image to keep or share ---------- */
  function summary() {
    const t = S.tool, v = S.v;
    if (t === 'strap') { const near = Math.round(v); return { label: T.t_strap, big: near + ' ' + MM, lines: [fill(T.r_measured, { v: n1(v) + ' ' + MM })], near }; }
    if (t === 'ring') { const C = S.mode === 'ring' ? v * Math.PI : v * 2, r = ringSizes(C); return { label: T.t_ring, big: 'EU ' + r.eu, ltr: true, lines: ['US ' + r.us + ' · UK ' + r.uk + ' · IT ' + r.it + ' · JP ' + r.jp, 'Ø ' + n2(r.d) + ' mm · C ' + n1(r.C) + ' mm'], tip: T.ring_tip }; }
    if (t === 'case') return { label: T.case_read, big: n1(v) + ' ' + MM, lines: [] };
    const C = 4 * v;
    if (S.mode === 'hand') { const b = bangle(C); return { label: T.m_hand, big: n1(b.dia) + ' ' + MM, lines: [fill(T.hand_read, { s: b.size, c: Math.round(C) })] }; }
    const cm = C / 10, A = STD.allow;
    return { label: T.m_wrist, big: n1(cm) + ' ' + CM, lines: [fill(T.wrist_read, { l: strapLength(cm), a: n1(cm + A.snug), b: n1(cm + A.comfort), c: n1(cm + A.loose) })] };
  }
  function result() {
    const s = summary();
    publish('smiths_sizer_result', { tool: S.tool }); // which tool, never the measurement
    const kids = [el('p', { class: 'sz-sh__k' }, s.label), el('p', { class: 'sz-sh__big', dir: 'auto' }, s.big), ...s.lines.map((x) => el('p', { class: 'sz-sh__l', dir: s.ltr ? 'ltr' : null }, x))];
    if (s.tip) kids.push(el('p', { class: 'sz-sh__tip' }, s.tip));
    const acts = el('div', { class: 'sz-sh__acts' });
    const share = btn(navigator.share ? T.share : T.save_img, 'ink', () => shareImage(s));
    acts.append(share, btn(T.again, 'line', () => { sheet.hidden = true; }));
    kids.push(acts);
    if (S.tool === 'strap') {
      const list = (D.straps || []).filter((p) => p.w === s.near && p.ok).slice(0, 4);
      if (list.length) {
        kids.push(el('p', { class: 'sz-sh__k', style: 'margin-top:22px' }, fill(T.straps_in, { w: s.near })));
        kids.push(el('div', { class: 'sz-sh__row' }, list.map((p) => el('a', { class: 'sz-mini', href: D.root + 'products/' + p.h + '?utm_source=sizer&utm_medium=ecosystem&utm_campaign=strap-' + s.near },
          el('div', { class: 's2-field' }, p.img ? el('img', { src: p.img, alt: '', loading: 'lazy', width: '240', height: '240' }) : null), el('span', {}, p.t)))));
        kids.push(el('a', { class: 'sz-sh__all', href: D.root + 'collections/straps?utm_source=sizer&utm_medium=ecosystem' }, T.all_straps));
      }
    }
    kids.push(el('p', { class: 'sz-sh__mark', dir: 'ltr' }, 'Smiths Sizer · smiths.watch/sizer'));
    sheet.replaceChildren(el('div', { class: 'sz-sh__in' }, kids));
    sheet.hidden = false;
    share.focus();
  }
  async function shareImage(s) {
    const c = document.createElement('canvas'); c.width = 1080; c.height = 1350;
    const g = c.getContext('2d');
    const ar = L === 'ar';
    try { await Promise.all(['600 120px Archivo', '500 30px "IBM Plex Mono"', '600 40px "IBM Plex Sans Arabic"'].map((f) => document.fonts.load(f))); } catch (e) { /* system fonts */ }
    g.fillStyle = '#F6F3EE'; g.fillRect(0, 0, 1080, 1350);
    g.strokeStyle = '#C9BFAD'; g.lineWidth = 2; g.strokeRect(48, 48, 984, 1254);
    // the logo is a same-origin theme asset; crossOrigin keeps the canvas exportable even if it is served from the CDN
    const logo = await new Promise((res) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = () => res(null); i.src = D.logo; });
    if (logo) { const w = 300, h = w * logo.naturalHeight / logo.naturalWidth; g.drawImage(logo, 540 - w / 2, 120, w, h); }
    else { g.fillStyle = '#16140F'; g.textAlign = 'center'; g.font = '500 64px Archivo'; g.fillText('S M I T H S', 540, 200); g.font = '500 22px Archivo'; g.fillText('B O U T I Q U E', 540, 246); }
    g.fillStyle = '#16140F'; g.fillRect(140, 300, 800, 2);
    g.textAlign = 'center'; g.direction = ar ? 'rtl' : 'ltr';
    g.fillStyle = '#9A5526'; g.font = ar ? '600 40px "IBM Plex Sans Arabic"' : '500 30px "IBM Plex Mono"';
    g.fillText(ar ? s.label : s.label.toUpperCase(), 540, 420);
    g.fillStyle = '#16140F'; g.direction = AR_RE.test(s.big) ? 'rtl' : 'ltr';
    let size = 190; g.font = `600 ${size}px Archivo`;
    while (g.measureText(s.big).width > 900 && size > 80) { size -= 10; g.font = `600 ${size}px Archivo`; }
    g.fillText(s.big, 540, 640);
    g.fillStyle = '#3E3A32'; g.direction = ar ? 'rtl' : 'ltr'; g.font = ar ? '500 38px "IBM Plex Sans Arabic"' : '400 36px Archivo';
    s.lines.forEach((ln, i) => wrap(g, ln, 540, 760 + i * 120, 860, 52));
    // a calliper drawing as the signature
    g.strokeStyle = '#9A5526'; g.lineWidth = 3;
    g.beginPath(); g.moveTo(400, 1030); g.lineTo(400, 1110); g.moveTo(680, 1030); g.lineTo(680, 1110); g.stroke();
    g.strokeStyle = '#C9BFAD'; g.lineWidth = 2; for (let x = 400; x <= 680; x += 14) { g.beginPath(); g.moveTo(x, 1070); g.lineTo(x, x % 70 === 50 ? 1088 : 1080); g.stroke(); }
    g.fillStyle = '#655E51'; g.direction = ar ? 'rtl' : 'ltr'; g.font = ar ? '500 32px "IBM Plex Sans Arabic"' : '500 26px "IBM Plex Mono"';
    g.fillText(ar ? T.measured_with : T.measured_with.toUpperCase(), 540, 1190);
    g.direction = 'ltr'; g.font = '500 26px "IBM Plex Mono"'; g.fillText('smiths.watch/sizer  ·  @smiths.oclock', 540, 1240);
    let blob = null;
    try { blob = await new Promise((res) => c.toBlob(res, 'image/png')); } catch (e) { blob = null; }
    if (!blob) return;
    const file = new File([blob], 'smiths-sizer-' + S.tool + '.png', { type: 'image/png' });
    publish('smiths_sizer_share', { tool: S.tool });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], title: 'Smiths Sizer', text: s.label + ': ' + s.big + ' — smiths.watch/sizer' }); return; } catch (e) { if (e && e.name === 'AbortError') return; }
    }
    const a = el('a', { href: URL.createObjectURL(blob), download: file.name }); document.body.append(a); a.click(); setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
  }
  function wrap(g, text, x, y, max, lh) {
    const words = String(text).split(' '); let line = '', yy = y;
    for (const w of words) { const t = line ? line + ' ' + w : w; if (g.measureText(t).width > max && line) { g.fillText(line, x, yy); line = w; yy += lh; } else line = t; }
    if (line) g.fillText(line, x, yy);
  }

  /* ---------- the page: tool buttons, calibration status ---------- */
  function syncStatus() {
    const k = R ? R.kind : 'wait';
    const txt = k === 'sure' ? fill(R.how === 'model' || R.how === 'shape' ? T.status_auto : T.status_set, { d: iso(R.full || R.label) }) : k === 'desk' ? T.status_desk : k === 'wait' ? T.status_wait : T.status_pick;
    root.querySelectorAll('[data-sz-status]').forEach((n) => { n.textContent = txt; n.classList.toggle('is-ok', k === 'sure'); });
    root.querySelectorAll('[data-sz-recal]').forEach((n) => { n.hidden = k === 'wait'; n.textContent = k === 'sure' ? T.change_dev : k === 'desk' ? T.on_phone : T.pick_now; });
  }
  root.querySelectorAll('[data-sz-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openTool(b.dataset.szOpen); }));
  root.querySelectorAll('[data-sz-recal]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openTool(S.tool || 'strap', R && R.kind === 'desk' ? 'desk' : 'pick'); }));
  syncStatus();
  ready.then(syncStatus);
  const h = (location.hash.match(/^#(strap|ring|case|wrist)\b/) || [])[1];
  if (h) openTool(h);
})();
